import Vue from 'vue'
import Vuex from 'vuex'
import pubFunction from '../public/index.js'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		hasLogin: false,
		token: '',
		userinfo: {
			name: '',
			avatar: '',
			realFlag: false
		},
		admLoginFlag: false,
		admToken: '',
		admUserInfo: {
			name: ''
		},
		websiteConfig: {
			imageUrl: '',
			richText: '',
			qrcodeUrl: '',
			addressList: [{
				name: '',
				address: '',
				lng: '',
				lat: '',
				tabs: [
					''
				]
			}],
			contact: [{
				name: '',
				value: ''
			}],
			company_name: '',
			company_name_en: '',
			zzdxywjyxkz: '',
			zzdxywjyxkz_kdq: '',
			jww: '',
			jwgaba: '',
			j_icp: '',
			copyright_time: '',
			web_name: ''
		},
		auctionKeyword: '',
		firstId: '',
		secondId: '',
		spaceKeyword: '',
		messageCommodity: {
			id: '',
			price: ''
		}
	},
	mutations: {
		login(state, token) {
			state.hasLogin = true;
			state.token = token
			pubFunction.setStorage('page_token', token)
		},
		logout(state) {
			state.hasLogin = false;
			state.token = ''
			state.userinfo = {
				name: '',
				realFlag: false
			}
			localStorage.removeItem('page_token')
			let current = router.history.current.path
			let spacePath = [
				'/space', '/record', '/collection', '/detail', '/footprint', '/setting', '/particular',
				'/security'
			]
			if (spacePath.indexOf(current) >= 0) {
				pubFunction.routerToLogin()
			}
		},
		saveUserinfo(state, userInfo) {
			state.userinfo = userInfo
			pubFunction.setStorage('userinfo', JSON.stringify(userInfo))
		},
		admLogin(state, token) {
			state.admLoginFlag = true
			state.admToken = token
			pubFunction.setStorage('adm_token', token)
		},
		admLogout(state) {
			state.admLoginFlag = false;
			state.admToken = ''
			localStorage.removeItem('adm_token')
			pubFunction.routerToAdmLogin()
		},
		saveAdmUserInfo(state, admUserInfo) {
			state.admUserInfo = admUserInfo
			pubFunction.setStorage('admUserInfo', JSON.stringify(admUserInfo))
		}
	},
	actions: {},
	modules: {}
})
